import { Button } from "@dash/form";
import { Dialog } from "@dash/dialog";
import { type CSSObject } from "@emotion/react";
import React, { useState } from "react";
import { MdOpenInNew } from "react-icons/md";

const visuallyHidden: CSSObject = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clipPath: "inset(50%)",
  whiteSpace: "nowrap",
  border: 0,
};

type Props = {
  modalTitle: string;
  embedHeightPx: number;
  children: (args: { containerCss: CSSObject }) => React.ReactNode;
};

export const CubeExpandableChartFrame: React.FC<Props> = ({ modalTitle, embedHeightPx, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const embedCss: CSSObject = { height: `${embedHeightPx}px`, maxWidth: "100%" };
  const modalInnerCss: CSSObject = {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    margin: "-1rem",
  };
  const modalChartCss: CSSObject = { flex: 1, minHeight: 0, width: "100%", position: "relative" };

  return (
    <>
      <div css={{ position: "relative", maxWidth: "100%" }}>
        <div
          css={{
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 1,
          }}
        >
          <Button
            variant="text"
            size="small"
            onClick={() => setIsOpen(true)}
            icon={<MdOpenInNew size="1.25rem" aria-hidden />}
            css={{ padding: "0.35rem 0.5rem", minHeight: 0, lineHeight: 1 }}
          >
            <span css={visuallyHidden}>Powiększ wykres</span>
          </Button>
        </div>
        {children({ containerCss: embedCss })}
      </div>
      {isOpen && (
        <Dialog header={modalTitle} onClose={() => setIsOpen(false)} placement="fullscreen">
          <div css={modalInnerCss}>{children({ containerCss: modalChartCss })}</div>
        </Dialog>
      )}
    </>
  );
};
